import React from 'react';
import styled from 'styled-components';
import { FiUserPlus, FiUserCheck } from 'react-icons/fi';

// 원본 크기: 636*1130
// 미리보기 크기: 360*720
// 스케일 비율: 360/636 = 0.566
const SCALE_RATIO = 360 / 636;

const PreviewWrapper = styled.div`
    width: 360px;
    height: ${1130 * SCALE_RATIO}px;
    position: relative;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;

const ScaledContainer = styled.div`
    width: 636px;
    height: 1130px;
    transform: scale(${SCALE_RATIO});
    transform-origin: top left;
    position: relative;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    flex: 1;
    padding: ${10 * SCALE_RATIO}vmin;
    background-image: ${props => {
        const defaultImage = 'https://kr.object.ncloudstorage.com/qnoss/clubdata/clubImage/kiosk_bg.png';
        let bgImage = defaultImage;
        if (props.imageURL) {
            if (props.imageURL.startsWith('http')) {
                bgImage = props.imageURL;
            } else if (props.imageURL.startsWith('clubImage/')) {
                bgImage = `https://kr.object.ncloudstorage.com/qnoss/clubdata/${props.imageURL}`;
            } else {
                bgImage = `https://kr.object.ncloudstorage.com/qnoss/clubdata/clubImage/${props.imageURL}`;
            }
        }
        return `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.8)), url(${bgImage})`;
    }};
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    color: white;
    position: relative;
    overflow: hidden;
`;

const GymName = styled.h1`
    font-size: ${props => (props.titleSize || 16) * SCALE_RATIO}px;
    font-weight: 800;
    margin-bottom: ${20 * SCALE_RATIO}px;
    line-height: 1.3;
    z-index: 1;
    text-align: center;
    width: 100%;
    text-shadow: 0 4px 20px rgba(0, 0, 0, 0.8);
    margin-top: 15vh;
    white-space: pre-line;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-word;
`;

const Subtitle = styled.p`
    font-size: ${props => (props.memoSize || 14) * SCALE_RATIO}px;
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 10vh;
    margin-top: ${15 * SCALE_RATIO}px;
    font-weight: 400;
    z-index: 1;
    text-align: center;
    width: 100%;
    max-width: 100%;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.8);
    white-space: pre-line;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-word;
    line-height: 1.5;
`;

const ButtonGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-md);
    width: 100%;
    z-index: 1;
    margin-top: auto;
    padding-bottom: 5vh;
`;

const PhoneText = styled.div`
    position: absolute;
    bottom: ${2 * SCALE_RATIO}vmin;
    left: 0;
    right: 0;
    font-size: ${3 * SCALE_RATIO}vmin;
    color: rgba(255, 255, 255, 0.9);
    font-weight: 400;
    z-index: 1;
    text-align: center;
    width: 100%;
    margin-bottom: 10px;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.8);
`;

const Card = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: ${4 * SCALE_RATIO}vmin ${6 * SCALE_RATIO}vmin;
    height: auto;
    min-height: ${12 * SCALE_RATIO}vh;
    background-color: rgba(20, 20, 25, 0.7);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 100px;
    backdrop-filter: blur(20px);
    transition: all 0.3s ease;
    cursor: pointer;
    width: 100%;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
`;

const IconWrapper = styled.div`
    margin: 0;
    padding: 0;
    background: none;
    border-radius: 0;
    transform: none;
    order: 2;
    color: white;
    
    svg {
        width: ${64 * SCALE_RATIO}px;
        height: ${64 * SCALE_RATIO}px;
    }
`;

const CardTitle = styled.h2`
    font-size: ${4 * SCALE_RATIO}vmin;
    font-weight: 600;
    margin: 0;
    color: white;
    order: 1;
`;

const HomePreview = ({ title, memo, imageURL, titleSize, memoSize, phone }) => {
    return (
        <PreviewWrapper>
            <ScaledContainer>
                <Container imageURL={imageURL}>
                    {title && (
                        <GymName titleSize={titleSize}>
                            {title}
                        </GymName>
                    )}
                    {memo && (
                        <Subtitle memoSize={memoSize}>
                            {memo}
                        </Subtitle>
                    )}
                    <ButtonGroup>
                        <Card>
                            <CardTitle>신규 회원</CardTitle>
                            <IconWrapper>
                                <FiUserPlus style={{ fontSize: `${64 * SCALE_RATIO}px`, color: '#00B8D4' }} />
                            </IconWrapper>
                        </Card>
                        <div style={{ height: '10px' }} />
                        <Card>
                            <CardTitle>기존 회원</CardTitle>
                            <IconWrapper>
                                <FiUserCheck style={{ fontSize: `${64 * SCALE_RATIO}px`, color: '#4CAF50' }} />
                            </IconWrapper>
                        </Card>
                    </ButtonGroup>
                    {phone && (
                        <PhoneText>
                            {phone}
                        </PhoneText>
                    )}
                </Container>
            </ScaledContainer>
        </PreviewWrapper>
    );
};

export default HomePreview;

